<template>
	<div :class="loseType!='请选择发布类型'?'PublishCollect':'PublishCollectt'">
		<div class="release">
			<div class="release_type">
				<div class="release_type_left">发布类型</div>
				<div class="release_type_right">
					<select v-on:change="releaseSelect" name="releaseType" v-model="loseType">
						<option value="请选择发布类型">请选择发布类型</option>
						<option value="丢失物品">丢失物品</option>
						<option value="捡到物品">捡到物品</option>
						<option value="人员走失">人员走失</option>
					</select>
				</div>
			</div>
			<div class="release_type" v-if="loseType=='丢失物品'">
				<div class="release_type_left">丢失地址</div>
				<div class="release_type_right">
					<input type="type" v-model="loseAddress" name="" id="" value="" placeholder="请输入丢失地址" />
				</div>
			</div>
			<div class="release_type" v-if="loseType=='捡到物品'">
				<div class="release_type_left">拾取地址</div>
				<div class="release_type_right">
					<input type="type" v-model="pickupAddress" name="" id="" value="" placeholder="请输入拾取地址" />
				</div>
			</div>
			<div class="release_type" v-if="loseType=='人员走失'">
				<div class="release_type_left">失踪人姓名</div>
				<div class="release_type_right">
					<input type="type" v-model="missingName" name="" id="" value="" placeholder="请输入失踪人姓名" />
				</div>
			</div>
			<div class="release_type" v-if="loseType=='人员走失'">
				<div class="release_type_left">失踪地址</div>
				<div class="release_type_right">
					<input type="type" v-model="missingAddress" name="" id="" value="" placeholder="请输入失踪地址" />
				</div>
			</div>
			<div class="release_type" v-if="loseType=='人员走失'">
				<div class="release_type_left">失踪人年龄</div>
				<div class="release_type_right">
					<input max="150" type="number" v-model="missingAge" name="" id="" value="" placeholder="请输入失踪人年龄" />
				</div>
			</div>
			<div class="release_type" v-if="loseType=='人员走失'">
				<div class="release_type_left">失踪人身高</div>
				<div class="release_type_right">
					<input type="number" v-model="missingHeight" name="" id="" value="" placeholder="请输入失踪人身高" />
				</div>
			</div>
			<div class="release_type" v-if="loseType=='人员走失'">
				<div class="release_type_left">失踪人性别</div>
				<div class="release_type_right">
					<select name="releaseType" v-model="missingGender">
						<option value="请选择失踪人性别">请选择失踪人性别</option>
						<option value="男">男</option>
						<option value="女">女</option>
					</select>
				</div>
			</div>
			<div class="release_describe" v-if="loseType!='请选择发布类型'">
				<div v-if="loseType!='人员走失'" class="release_type_top">描述</div>
				<div v-if="loseType=='人员走失'" class="release_type_top">失踪人详细描述</div>
				<div class="release_type_bottom">
					<div class="file_container">
						<textarea v-if="loseType!='人员走失'" @input="file_change" v-model="describe" class="file_text" name="file_text" rows="" maxlength="500" cols="" placeholder="请输入详细描述"></textarea>
						<textarea v-if="loseType=='人员走失'" @input="file_change" v-model="missingDescribe" class="file_text" name="file_text" rows="" maxlength="500" cols="" placeholder="请详细描述失踪人的失踪经过和身体特征（穿着、服饰 等），如有其他备注也可以在此填写。"></textarea>
					</div>
					<div class="file_num"><span>{{file_num}}</span>/500</div>
				</div>
				<div class="inp_file" v-if="loseType!='请选择发布类型'">
					<div v-if="fill_img" class="file" v-show="true">
						<div class="file_img">
							<img :src="fill_img" />
						</div>
						<input type="file" name="" id="" value="" />
						<div class="file_no" @click="Delete_two">
							<img src="../assets/file_no.png" />
						</div>
					</div>
					<div v-else="" class="file" v-show="false">
						<div class="file_img">
							<img src="../assets/file_one.png" />
						</div>
						<input type="file" name="" id="" value="" />
						<div class="file_no" @click="Delete_two">
							<img src="../assets/file_no.png" />
						</div>
					</div>
					<div class="file">
						<div class="file_img">
							<img src="../assets/file_one.png" />
						</div>
						<form id="uploadForm_two" enctype="multipart/form-data">
							<input id="upload2" accept="image/*" type="file" name="upload" multiple="multiple" v-on:change="uploadFile_two()" />
							<!--<button name="upload1" id="upload1" type="button" onclick="uploadFile()">upload</button>-->
						</form>
					</div>
				</div>
			</div>
		</div>
		<div :class="loseType!='请选择发布类型'?'release_btn_btn':'release_btn'">
			<div class="release_btn_cli" @click="Submitted">提交</div>
		</div>
		<div class="yin_ts" v-if="yin">
			<div class="buttom_x" v-if="!success_img"><img src="../assets/buttom_x.png" /></div>
			<div class="buttom_x" v-if="success_img"><img src="../assets/success.png" /></div>
			<div class="text">{{yin_text}}</div>
			<div v-if="success_img" class="text">请耐心等待审核</div>
			<div class="title" v-if="!success_img">请确认信息</div>
			<div class="buttom_text" @click="modify">{{buttom_text}}</div>
		</div>
		<div class='view_yinyin' v-if="yin" catchtouchmove="return" @click="modify"></div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: "PublishCollect",
		data() {
			return {
				baseUrl: "",
				baseUrlOne: "",
				loseType: '请选择发布类型',
				loseAddress: "",
				describe: "",
				file_num: 0,
				pickupAddress: "",
				fill_img: "",
				yin: false,
				yin_text: "",
				success_img: true,
				missingName: "",
				missingAddress: "",
				missingAge: "",
				missingHeight: "",
				missingGender: "请选择失踪人性别",
				missingDescribe: "",
				showBtn: true,
				access_token: "",
				buttom_text: "去修改",
				clientHeight: document.documentElement.clientHeight,
				
			}
		},
		methods: {
			releaseSelect() {
				var that = this;
				that.fill_img = '';
				that.describe = '';
				that.missingDescribe = '';
				that.missingName = '';
				that.missingAddress = '';
				that.missingAge = '';
				that.missingHeight = '';
				that.missingGender = '请选择失踪人性别';
				that.loseAddress = '';
				that.pickupAddress = '';
				that.file_num=0;
			},
			file_change() {
				var that = this;
				if(that.loseType == '人员走失') {
					that.file_num = that.missingDescribe.length;
					if(that.describe.length >= 500) {
						that.file_num = 500;
						that.describe = that.describe;
					}
				} else {
					that.file_num = that.describe.length;
					if(that.describe.length >= 500) {
						that.file_num = 500;
						that.describe = that.describe;
					}
				}

			},
			Delete_two() {
				var that = this;
				that.fill_img = ""
			},
			uploadFile_two() {
				var that = this;
				wclient.view.showLoading();
				$.ajax({
					url: that.baseUrlOne + '/account/upload/image/uploads',
					type: 'POST',
					cache: false,
					data: new FormData($('#uploadForm_two')[0]),
					processData: false,
					contentType: false
				}).done(function(res) {
					var data = $.parseJSON(res);
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						that.fill_img = data.imageurl[0].imageurl;
					} else {
						that.yin = true;
						that.yin_text = '请上传图片';
						that.success_img = false;
					}
				}).fail(function(res) {});
			},
			modify() {
				var that = this;
				if(that.buttom_text == '确定') {
					that.$router.push({
						name: 'Seek'
					});
				} else {
					that.yin = false;
				}
			},
			Submitted() {
				var that = this;
				if(that.loseType == '请选择发布类型') {
					that.yin = true;
					that.yin_text = '请选择发布类型';
					that.success_img = false;
				} else if(that.loseType == '丢失物品') {
					if(that.loseAddress == '') {
						that.yin = true;
						that.yin_text = '请输入丢失地址';
						that.success_img = false;
					} else if(that.describe == '') {
						that.yin = true;
						that.yin_text = '请输入详细描述';
						that.success_img = false;
					} else {
						wclient.view.showLoading();
						wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
						wclient.ajax({
							type: "GET",
							url: that.baseUrl + '?ugi=lostarticle&action=lostregister',
							dataType: "json",
							async: true,
							data: {
								access_token: that.access_token,
								losttype: 'lossgoods',
								lostaddress: that.loseAddress,
								remarks: that.describe,
								image: that.fill_img
							},
							success: function(data) {
								wclient.view.hideLoading();
								if(data.code == 'A00006') {
									that.yin = true;
									that.yin_text = '发布成功';
									that.success_img = true;
									that.buttom_text = '确定';
								} else {
									that.yin = true;
									that.yin_text = data.errmsg;
									that.success_img = false;
								}
							}
						});
					}
				} else if(that.loseType == '捡到物品') {
					if(that.pickupAddress == '') {
						that.yin = true;
						that.yin_text = '请输入拾取地址';
						that.success_img = false;
					} else if(that.describe == '') {
						that.yin = true;
						that.yin_text = '请输入详细描述';
						that.success_img = false;
					} else {
						wclient.view.showLoading();
						wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
						wclient.ajax({
							type: "GET",
							url: that.baseUrl + '?ugi=lostarticle&action=lostregister',
							dataType: "json",
							async: true,
							data: {
								access_token: that.access_token,
								losttype: 'lostfound',
								lostaddress: that.pickupAddress,
								remarks: that.describe,
								image: that.fill_img
							},
							success: function(data) {
								wclient.view.hideLoading();
								if(data.code == 'A00006') {
									that.yin = true;
									that.yin_text = '发布成功';
									that.success_img = true;
									that.buttom_text = '确定';
								} else {
									that.yin = true;
									that.yin_text = data.errmsg;
									that.success_img = false;
								}
							}
						});
					}
				} else if(that.loseType == '人员走失') {
					if(that.missingName == '') {
						that.yin = true;
						that.yin_text = '请输入失踪人姓名';
						that.success_img = false;
					} else if(that.missingAddress == '') {
						that.yin = true;
						that.yin_text = '请输入失踪地址';
						that.success_img = false;
					} else if(that.missingAge == '') {
						that.yin = true;
						that.yin_text = '请输入失踪人年龄';
						that.success_img = false;
					} else if(that.missingAge<0||that.missingAge>200) {
						that.yin = true;
						that.yin_text = '请输入正确的失踪人年龄';
						that.success_img = false;
					} else if(that.missingHeight == '') {
						that.yin = true;
						that.yin_text = '请输入失踪人身高';
						that.success_img = false;
					} else if(that.missingHeight<0||that.missingHeight>300) {
						that.yin = true;
						that.yin_text = '请输入正确的失踪人身高';
						that.success_img = false;
					} else if(that.missingGender == '') {
						that.yin = true;
						that.yin_text = '请输入失踪人性别';
						that.success_img = false;
					} else if(that.missingDescribe == '') {
						that.yin = true;
						that.yin_text = '请输入失踪人详细描述';
						that.success_img = false;
					} else if(that.fill_img == '') {
						that.yin = true;
						that.yin_text = '请上传图片';
						that.success_img = false;
					} else {
						if(that.missingGender == '男') {
							var tracksex = '1'
						} else {
							var tracksex = '2'
						}
						wclient.view.showLoading();
						wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
						wclient.ajax({
							type: "GET",
							url: that.baseUrl + '?ugi=tracking&action=releasetrackgrecord',
							dataType: "json",
							async: true,
							data: {
								access_token: that.access_token,
								trackname: that.missingName,
								trackage: that.missingAge,
								height: that.missingHeight,
								tracksex: tracksex,
								trackaddress: that.missingAddress,
								trackdescribe: that.missingDescribe,
								trackimg: that.fill_img
							},
							success: function(data) {
								wclient.view.hideLoading();
								if(data.code == 'A00006') {
									that.yin = true;
									that.yin_text = '发布成功';
									that.success_img = true;
									that.buttom_text = '确定';
								} else {
									that.yin = true;
									that.yin_text = data.errmsg;
									that.success_img = false;
								}
							}
						});
					}
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
				var baseUrlOne = "http://xs.weapi.org";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
				var baseUrlOne = "http://xs.weapi.org";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/reception/ajax";
				var baseUrlOne = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			that.baseUrlOne = baseUrlOne;
			that.access_token = localStorage.getItem('access_token');
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}

			}
		}
	}
</script>

<style scoped>
	.PublishCollect {
		width: 100%;
		height: 100%;
		background: white;
		-webkit-overflow-scrolling: touch;
	}
	
	.PublishCollectt {
		width: 100%;
		height: 100vh;
		background: white;
		-webkit-overflow-scrolling: touch;
	}
	
	.release {
		width: 100%;
	}
	
	.release_type {
		width: 90%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 15px 5%;
		border-bottom: 1px solid #DBDBDB;
		font-size: 15px;
		color: black;
	}
	
	select {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border: none;
		outline: none;
		font-size: 15px;
		color: #B1B1B1;
		background: white !important;
		direction: rtl;
	}
	
	select option {
		direction: ltr;
	}
	
	input {
		border: none;
		outline: none;
		text-align: right;
		font-size: 15px;
		color: #797979;
	}
	
	.release_btn {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background: white;
		padding: 15px 0;
		border-top: 1px solid #DBDBDB;
	}
	.release_btn_btn {
		width: 100%;
		background: white;
		padding: 15px 0;
		border-top: 1px solid #DBDBDB;
	}
	.release_btn_cli {
		width: 70%;
		margin: 0 auto;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 40px;
		text-align: center;
		color: white;
		border-radius: 20px;
	}
	
	.release_describe {
		width: 90%;
		padding: 0 5% 55px;
	}
	
	.release_type_top {
		width: 100%;
		padding: 15px 0;
		font-size: 15px;
	}
	
	.release_type_bottom {
		width: 100%;
		border: 1px solid rgba(222, 222, 222, 1);
	}
	
	.file_container {
		width: 100%;
		position: relative;
	}
	
	.file_text {
		display: block;
		width: 90%;
		height: 160px;
		background: white;
		outline: none;
		padding: 20px 5% 0;
		font-size: 14px;
		overflow: hidden;
		border-radius: 4px;
		resize: none;
		line-height: 20px;
		border: none;
		overflow-y: scroll;
	}
	
	.file_num {
		color: rgba(180, 180, 180, 1);
		width: 90%;
		text-align: right;
		line-height: 45px;
		margin: 0 auto;
	}
	
	.inp_file {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		margin-bottom: 20px;
	}
	
	.file {
		float: left;
		position: relative;
		width: 110px;
		height: 120px;
		margin-top: 10px;
		margin-right: 10px;
	}
	
	.file_img {
		float: left;
		width: 100%;
		height: 100%;
		border-radius: 10px;
	}
	
	.file input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0px;
		top: 0px;
		opacity: 0;
		-ms-filter: 'alpha(opacity=0)';
	}
	
	.file_no {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		box-shadow: 0px 1px 7px 2px rgba(154, 154, 154, 0.2);
		color: #9A9A9A;
		background: rgb(252, 245, 247);
	}
	
	.view_yinyin {
		width: 100vh;
		height: 100vh;
		background: rgba(0, 0, 0, .3);
		position: fixed;
		top: 0;
		overflow: hidden
	}
	
	.yin_ts {
		position: fixed;
		top: 25%;
		background: #fff;
		z-index: 999;
		border-radius: 20px;
		width: 60%;
		left: 50%;
		margin-left: -30%;
		text-align: center;
	}
	
	.buttom_x {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 20px 0;
	}
	
	.buttom_x img {
		width: 55px;
	}
	
	.text {
		font-size: 18px;
		font-family: PingFangSC-Medium;
		font-weight: 600;
		color: rgba(55, 55, 55, 1);
	}
	
	.title {
		font-weight: 400;
		color: rgba(164, 164, 164, 1);
		font-size: 16px;
		line-height: 30px;
		padding-bottom: 10px;
	}
	
	.buttom_text {
		color: rgba(228, 4, 4, 1);
		line-height: 50px;
		font-size: 16px;
		font-weight: bold;
		border-top: 1px rgb(225, 225, 225) solid;
		margin-top: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/components/PublishCollect.vue